import React, { Component } from "react";
import { socialHandles, ProgrmmingHandles } from "./Handles";
import AOS from "aos";

class ContactMe extends Component {
  componentDidMount() {
    AOS.init({ duration: 2000 });
  }
  render() {
    return (
      <div className="contactme-section">
        <div
          className="heading"
          data-aos="fade-up"
          data-aos-anchor=".project-section"
          data-aos-anchor-placement="bottom-bottom"
        >
          Contact Me
        </div>
        <div
          className="subheading"
          data-aos="fade-left"
          data-aos-anchor=".project-section"
          data-aos-anchor-placement="bottom-bottom"
        >
          Social Media Handles
        </div>
        {socialHandles.map((handle) => {
          return (
            <a
              href={handle.site}
              style={{
                background: `url(${handle.icon})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundColor: "white",
              }}
              className="handle-btn"
            ></a>
          );
        })}
        <div
          className="subheading"
          data-aos="fade-right"
          data-aos-anchor=".project-section"
          data-aos-anchor-placement="bottom-bottom"
        >
          Programming Handles
        </div>
        {ProgrmmingHandles.map((handle) => {
          return (
            <a
              href={handle.site}
              style={{
                background: `url(${handle.icon})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundColor: "white",
              }}
              className="handle-btn"
            ></a>
          );
        })}
        {/* <iframe
          src="https://app.api.edu.buncee.com/player/72fd5ed8e1fd4ebd8f72a6cf8e8b154a?embed=1&render_slide_panel=0"
          width="1920"
          height="1080"
          allowFullScreen
        ></iframe> */}
      </div>
    );
  }
}

export default ContactMe;
